/**
 * Angular imports.
 */
import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';

/**
 * Library imports.
 */
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import * as Bowser from 'bowser';

/**
 * Datepicker Component
 */
@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnChanges, OnInit {
  @Input() minDate;
  @Input() maxDate;
  @Input() dateFor;
  @Input() isvalid;
  @Input() isDisabled;
  @Input() plhldr;
  @Input() errMsg;
  @Input() defaultVal;
  @Input() dpPlacement;
  @Input() isLeftIcon;
  @Input() datePickerClass = 'form-control';
  @Output() setDate = new EventEmitter();
  public componentPlacement = 'auto';
  public bw = null;
  public err_msg = '';
  private _picker: BsDatepickerDirective;
  public value;

  /**
   * Necessary instances.
   */
  constructor(private localeService: BsLocaleService) {
    this.bw = Bowser.getParser(window.navigator.userAgent);
    enGbLocale.invalidDate = '';
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    
  }

  ngOnInit(): void {
    if(this.defaultVal) {
      this.value = JSON.parse(JSON.stringify(this.defaultVal));
      this.value = new Date(this.value);
    }
  }

  /**
   * ios Less Than 13
   */
  public iosLessThan13(): boolean {
    if (this.bw.parsedResult.os.name == 'iOS' && parseFloat(this.bw.parsedResult.os.version) < 13) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ios More Than 12
   */
  public iosMoreThan12(): boolean {
    if (this.bw.parsedResult.os.name == 'macOS' ||  // iPad OS ¬¬
      (this.bw.parsedResult.os.name == 'iOS' && parseFloat(this.bw.parsedResult.os.version) >= 13)) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * isSafari Touch
   */
  public isSafariTouch(): boolean {
    if ((window as any)?.Modernizr?.touchevents && this?.bw?.parsedResult?.platform?.vendor == 'Apple') {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    if (this.dpPlacement) {
      this.componentPlacement = this.dpPlacement;
    }
    document.querySelector('body')?.classList?.add('calendar-design');

    if (this.minDate && this.value && this.minDate > this.value) {
      this.value = undefined;
    }
  }

  /**
   * onDate Change
   */
  onDateChange(value: Date): void {
    this.err_msg = '';
    const temp = { Date: value, dateFor: this.dateFor };
    this.setDate.emit(temp);
  }

  /**
   * onShow Picker
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onShowPicker(event: any): void {
    const dayHoverHandler = event.dayHoverHandler;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hoverWrapper = (hoverEvent: any): void => {
      const { cell, isHovered } = hoverEvent;

      if (isHovered && this.isSafariTouch() &&
        ((this.iosMoreThan12() && cell.isHovered) || this.iosLessThan13())
      ) {
        try {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (this._picker as any)._datepickerRef.instance.daySelectHandler(cell);
        } catch (e) {
          // Handle Error
        }
      }

      return dayHoverHandler(hoverEvent);
    };

    event.dayHoverHandler = hoverWrapper;
  }
}
